import a, { AxiosError } from 'axios';

const axios = a.create();

axios.defaults.baseURL = process.env.REACT_APP_MONOLITH_URL;
axios.defaults.withCredentials = true;

export async function registerBuyer(params: Record<string, string | number | boolean>) {
  try {
    await axios.post('/api/buyers/register', params);

    return {
      hasErrors: false,
      errors: {},
    };
  } catch (error: unknown) {
    if (a.isAxiosError(error) && error.response?.data) {
      const { errors = {} } = error.response.data as { errors?: Record<string, string> };
      const {
        first_name,
        last_name,
        email,
        business_phone,
        mobile_phone,
        password,
        password_confirmation,
        business_name,
        tax_id_number,
        business_license,
        country,
        state,
        city,
        street,
        zip_code,
        category,
      } = errors;
      return {
        hasErrors: true,
        errors: {
          first_name,
          last_name,
          email,
          business_phone,
          mobile_phone,
          password,
          password_confirmation,
          business_name,
          tax_id_number,
          business_license,
          country,
          state,
          city,
          street,
          zip_code,
          jewelry: category,
        },
      };
    }

    window.rollbar?.error('BuyersPortal: Failed to register buyer');
    return {
      hasErrors: true,
      errors: {},
    };
  }
}
